<template>
  <div class="body">
    <div id="uiContainer" class="uiContainer"></div>
    <div id="container" class="container"></div>


    <div class="baseBoxLeft" v-show="showDataBox">
      <div class="boxTitle">实时监测</div>
      <div class="cameraList">
        <div class="camera">
          <div class="camera_content" alt="" />
          <span class="camera_text">监控摄像1</span>
        </div>
      </div>
      <div class="senssion">
        <div class="senssion_item">
          <img class="senssion_item_img" :src="require('@/assets/senssion/temp.png')" />
          <p>{{ temp }}</p>
        </div>
        <div class="senssion_item">
          <img class="senssion_item_img" :src="require('@/assets/senssion/hum.png')" />
          <p>{{ hum }}</p>
        </div>
        <div class="senssion_item">
          <img class="senssion_item_img" :src="require('@/assets/senssion/winddrection.png')" />
          <p>风向：东南风</p>
        </div>
        <div class="senssion_item">
          <img class="senssion_item_img" :src="require('@/assets/senssion/windspeed.png')" />
          <p>风速：2m/s</p>
        </div>
        <div class="senssion_item">
          <img class="senssion_item_img" :src="require('@/assets/senssion/rain.png')" />
          <p>降雨量：0mm</p>
        </div>
        <div class="senssion_item">
          <img class="senssion_item_img" :src="require('@/assets/senssion/evaporation.png')" />
          <p>蒸发量：0.326mm/h</p>
        </div>
        <div class="senssion_item">
          <img class="senssion_item_img" :src="require('@/assets/senssion/airpressure.png')" />
          <p>气压：0.326MPa</p>
        </div>
      </div>
    </div>

    <a class="introdution" @click="onStartClick" v-show="showIntrodution">
      <img :src="require('@/assets/pcControll.png')" />
    </a>
    <a-modal title="请输入密码" :visible="ShowPasswordInput" @ok="getViewAuth" @cancel="handleCancel" maskclosable="false">
      <a-input v-model="password" />
    </a-modal>
    <!-- 模型展示界面 -->
    <dir class="colorpicker_container" v-show="isshowcolorpicker">
      <sketch-picker class="colorpicker" v-model="color" @input="colorValueChange"></sketch-picker>
      <button class="colorpicker" type="button" @click="changeColor" style="
          width: 222px;
          background-color: rgb(255, 255, 255);
          border: none;
          outline: none;
          border-radius: 5px;
          cursor: pointer;
        ">
        确&#32;定
      </button>
    </dir>
    <div class="footer">
      <!-- <img
        class="foot_button"
        :src="require('@/assets/info.png')"
        height="40"
        width="40"
        @click="showInfo"
      /> -->
      <img class="foot_button" :src="require('@/assets/info.png')" height="40" width="40" @click="modelInfo" />
      <a-dropdown :placement="view_placement" :trigger="['click']">
        <img class="foot_button" :src="require('@/assets/view.png')" height="30" width="30" />
        <a-menu slot="overlay">
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/top.png')" @click="view_top" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/bottom.png')" @click="view_bottom" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/front.png')" @click="view_front" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/back.png')" @click="view_back" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/left.png')" @click="view_left" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/right.png')" @click="view_right" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/reset.png')" @click="viewReturnOrigin" />
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <a-dropdown :placement="view_placement" :trigger="['click']">
        <img class="foot_button" :src="require('@/assets/trim.png')" height="30" width="30" />
        <a-menu slot="overlay">
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/trim_top.png')" @click="trim_top" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/trim_front.png')" @click="trim_front" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/trim_right.png')" @click="trim_right" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/reset.png')" @click="dont_trim" />
          </a-menu-item>
        </a-menu>
      </a-dropdown>
      <img class="foot_button" :src="require('@/assets/backGroundColor.png')" height="40" width="40"
        @click="changcolorclick" />
      <img class="foot_button" :src="require('@/assets/720.png')" height="40" width="40" v-if="model.vrAddr"
        @click="openVR" />
      <img class="foot_button" :src="require('@/assets/Share.png')" height="40" width="40"
        @click="onShareButtonClick" />
      <a-dropdown :placement="view_placement" :trigger="['click']">
        <img class="foot_button" :src="require('@/assets/more1.png')" height="30" width="30" />
        <a-menu slot="overlay">
          <a-menu-item>
            <img class="foot_button" :src="require('@/assets/explode1.png')" @click="explode" />
          </a-menu-item>
          <a-menu-item>
            <img class="foot_button" v-if="showOpactyButton" :src="require('@/assets/opacty.png')" @click="setOpacty" />
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
    <img id="logo" :src="'./model/show/' + model.logoPath" v-show="model.logoPath ? true : false" style="
        display: inline-block;
        height: 40px;
        width: auto;
        position: absolute;
        top: 30px;
        left: 30px;
      " />
    <!--左边工具栏-->
    <div class="leftbar" id="leftbar" style="visibility:hidden">
      <div class="leftbar-item" id="up">
        <img class="leftbar-item-image" :src="require('@/assets/up.png')" />
      </div>
      <p class="floor_shower"></p>
      <div class="leftbar-item" id="down">
        <img class="leftbar-item-image" :src="require('@/assets/down.png')" />
      </div>
    </div>
    <a-progress type="dashboard" v-show="this.modelView.showProgress" :percent="this.modelView.progress" style="
        position: absolute;
        left: 50%;
        top: 50%;
        margin-top: -50px;
        margin-left: -50px;
      " />
    <!--展示模型信息-->
    <a-modal v-model="modelInfoVisible" title="模型信息" on-ok="handleOk_modelInfo">
      <template slot="footer">
        <a-button key="submit" type="primary" @click="handleOk_modelInfo">
          确定
        </a-button>
      </template>
      <p v-html="model.remark"></p>
    </a-modal>
    <a-drawer class="shareDrawer" :title="shareDrawer.title" :placement="shareDrawer.placement"
      :visible="shareDrawer.visible" @close="onCloseShareDiv">
      <share :config="config"
        style="display:flex; flex-direction:column; align-items:center; justify-content:space-between; height: 600px;">
      </share>
    </a-drawer>
  </div>
</template>

<script>
import * as THREE from "three";
import { Sketch } from "vue-color";
import { Server } from "../../../js/Server/Server";
import { SceneManager } from "../../../js/Scene/SceneManager";

export default {
  metaInfo: {
    meta: [{ charset: "utf-8" }],
  },
  components: {
    "sketch-picker": Sketch,
  },
  name: "Model",
  data() {
    return {
      intitClipe: false,
      server: new Server(),
      sceneManager: null,
      enableShadow: true,
      view_placement: "topCenter",
      firstTimeOnlocal: "true",
      showIntrodution: true,
      //颜色板的颜色
      color: "",
      //分享相关变量
      config: {
        url: "", // 网址，默认使用 window.location.href
        source: "云南大筑科技", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        image: "", // 图片, 默认取网页中第一个img标签
        sites: ["qzone", "qq", "weibo", "wechat"], // 启用的站点
        disabled: [], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
      },
      shareDrawer: {
        title: "分享到：",
        visible: false,
        placement: "right",
      },
      modelInfoVisible: false,
      isshowcolorpicker: false,
      modelView: {
        title: "",
        showProgress: false,
        progress: 0,
        logoShow: true,
      },
      scene: null,
      camera_p: null,
      camera_o: null,
      renderer: null,
      controls: null,
      clock: new THREE.Clock(),
      ShowPasswordInput: false,
      password: "",
      meta: [],
      loadedObj: null,
      model: {
        backgroundColor: "rgb(222,222,222)",
        coverPath: "",
        enableView: "",
        needPassword: false,
        password: "",
        modelPath: "",
        id: "",
        logoPath: "",
        mapsPath: "",
        Name: "",
        path: "",
        remark: "",
        uploadTime: "",
        vrAddr: "",
      },
      initInfo: {
        camera_x_position: 30,
        camera_y_position: 30,
        camera_z_position: 30,
        enableMainLight: true,
        mainLightIntensity: 0.1,
        enableShadow: false,
        enableLightProbe: true,
        enableEnvironmentLight: true,
        environmentLightIntensity: 0.6,
      },
      enableClip_y: false,
      enableClip_x: false,
      enableClip_z: false,
      exploded: false,
      isOpacty: false,
      showOpactyButton: false,
      explodeModel: null,

      //数据可视化
      showDataBox: false,
      temp: "温度：16.6℃",
      hum: "湿度：60.5%",
    };
  },
  mounted() {
    this.modelView.showProgress = true;
    this.model.id = this.$route.query.id;
    var id_obj = { id: this.model.id };
    this.initScene();
    this.server.getModel(id_obj, this.getMoldeCallBack);
    let firstTime = localStorage.getItem("firstTimeOnlocal");
    if (firstTime == "false") {
      this.firstTimeOnlocal = false;
      this.showIntrodution = false;
    } else {
      let secondsToGo = 7;
      const interval = setInterval(() => {
        secondsToGo -= 1;
      }, interval);
      setTimeout(() => {
        clearInterval(interval);
        this.showIntrodution = false;
      }, secondsToGo * 1000);
    }
    localStorage.setItem("firstTimeOnlocal", false);
    window.onresize = () => {
      this.onWindowResize();
    };
  },
  destroyed() {
    if (this.sceneManager) {
      this.sceneManager.closeWebSocket();
    }
  },
  methods: {
    getMoldeCallBack(model) {
      this.model = model.model;
      if (this.model.initInfo) {
        this.initInfo = JSON.parse(this.model.initInfo);
      }
      this.sceneManager.configEvironment(this.initInfo, this.enableShadow);
      this.sceneManager.setBackGroundColor(this.model.backgroundColor);
      this.modelView.title = this.model.name;
      this.modelView.logoShow = true;
      this.config.url = window.location.href.replace("Model", "m_Model");
      this.config.title = this.model.name;
      this.config.description = this.model.remark;
      this.config.image = "./model/show/" + model.coverPath;
      if (this.model.needPassword == "true") {
        this.ShowPasswordInput = true;
      } else document.title = model.name;
      this.meta = [
        { property: "og:type", content: "website" },
        { property: "og:title", content: "页面标题" },
        { property: "og:description", content: "页面描述" },
        {
          property: "og:image",
          // content: "./model/show/" + model.logoPath,
        },
        { property: "og:url", content: "http://www.example.com/" },
      ];
      if (!this.model.modelFileType) {
        this.model.modelFileType = this.model.modelPath.substring(
          this.model.modelPath.lastIndexOf(".") + 1
        );
      }
      let modPath = "./model/show/" + this.model.modelPath;
      let mapPath;
      if (this.model.mapsPath == "" || this.model.mapsPath == null) {
        mapPath = "";
      } else {
        mapPath =
          this.model.path + "/" + this.model.mapsPath + "/";
      }
      this.sceneManager.loadModel(
        modPath,
        mapPath,
        this.model.modelFileType,
        this.progress,
        this.modelLoadFinish
      );
    },
    getViewAuth() {
      if (this.password == this.model.password) {
        this.ShowPasswordInput = false;
      } else {
        this.$message.error("密码错误");
      }
    },
    handleCancel() {
      this.ShowPasswordInput = false;
    },
    getModel(id) { },
    //#region 视图操作
    view_top() {
      this.sceneManager.transformCamera(
        { x: 0, y: 100, z: 0 },
        { x: 0, y: 0, z: 0 }
      );
      this.tweenanimate();
    },
    view_bottom() {
      this.sceneManager.transformCamera(
        { x: 0, y: -100, z: 0 },
        { x: 0, y: 0, z: 0 }
      );
      this.tweenanimate();
    },
    view_front() {
      this.sceneManager.transformCamera(
        { x: 300, y: 0, z: 0 },
        { x: 0, y: 0, z: 0 }
      );
      this.tweenanimate();
    },
    view_back() {
      this.sceneManager.transformCamera(
        { x: -300, y: 0, z: 0 },
        { x: 0, y: 0, z: 0 }
      );
      this.tweenanimate();
    },
    view_left() {
      this.sceneManager.transformCamera(
        { x: 0, y: 0, z: -300 },
        { x: 0, y: 0, z: 0 }
      );
      this.tweenanimate();
    },
    view_right() {
      this.sceneManager.transformCamera(
        { x: 30, y: 0, z: 300 },
        { x: 0, y: 0, z: 0 }
      );
      this.tweenanimate();
    },

    trim_top() {
      this.enableClip_y = !this.enableClip_y;
      if (this.enableClip_y) {
        this.sceneManager.clipe(1);
      } else {
        this.sceneManager.closeClipe(1);
      }
    },
    trim_bottom() { },
    trim_front() {
      this.enableClip_x = !this.enableClip_x;
      if (this.enableClip_x) {
        this.sceneManager.clipe(0);
      } else {
        this.sceneManager.closeClipe(0);
      }
    },
    trim_back() { },
    trim_left() { },
    trim_right() {
      this.enableClip_z = !this.enableClip_z;
      if (this.enableClip_z) {
        this.sceneManager.clipe(2);
      } else {
        this.sceneManager.closeClipe(2);
      }
    },
    dont_trim() {
      this.enableClip_x = false;
      this.enableClip_y = false;
      this.enableClip_z = false;
      this.sceneManager.closeClipe(-1);
    },
    //#endregion

    explode() {
      if (!this.exploded) {
        this.sceneManager.explodeModel.explode();
        this.exploded = true;
      } else {
        this.sceneManager.explodeModel.resetExplode();
        this.exploded = false;
      }
    },
    setOpacty() {
      this.isOpacty = !this.isOpacty;
      this.sceneManager.setOpacty(this.isOpacty);
    },

    //选择颜色
    changcolorclick() {
      this.isshowcolorpicker = !this.isshowcolorpicker;
    },
    showInfo() {
      this.sceneManager.showInfo();
    },
    //模型信息
    modelInfo() {
      this.modelInfoVisible = true;
    },
    handleOk_modelInfo() {
      this.modelInfoVisible = false;
    },
    colorValueChange(val) {
      var bgColor = colorRgb(val.hex);
      this.model.backgroundColor = bgColor;
      this.sceneManager.setBackGroundColor(this.model.backgroundColor);
    },
    changeColor() {
      this.isshowcolorpicker = false;
      this.server.updateColor(this.model);
    },
    openVR() {
      window.open(this.model.vrAddr);
    },
    onShareButtonClick() {
      this.shareDrawer.visible = !this.shareDrawer.visible;
    },
    onCloseShareDiv() {
      this.shareDrawer.visible = false;
    },
    onStartClick() {
      this.showIntrodution = false;
    },
    viewReturnOrigin() {
      this.sceneManager.viewReturnOrigin();
    },
    upfloor() {

    },
    downfloor() {

    },
    initScene() {
      this.sceneManager = new SceneManager(this.model.id);
      this.sceneManager.setFloorUI(document.getElementById("leftbar"));
      this.sceneManager.enableShadow = this.enableShadow;
      let doElement = this.sceneManager.initScene(
        this.model.backgroundColor,
        document,
        this.onSenssionClick,
        this.onSenssionMessage
      );

      let container = document.getElementById("container");
      container.childNodes.forEach((childNode) => {
        container.removeChild(childNode);
      });
      container.appendChild(doElement[0]);

      let uiContainer = document.getElementById("uiContainer");
      uiContainer.childNodes.forEach((childNode) => {
        uiContainer.removeChild(childNode);
      });
      uiContainer.appendChild(doElement[1]);

      this.animate();
    },

    onWindowResize() {
      this.sceneManager.onWindowResize();
    },
    animate() {
      requestAnimationFrame(this.animate);
      const delta = this.clock.getDelta();
      if (this.mixer)
        this.mixer.update(delta);
      this.sceneManager.animate();
    },
    tweenanimate() {
      var id = requestAnimationFrame(this.tweenanimate);

      var result = this.sceneManager.tweenanimate();

      if (!result) cancelAnimationFrame(id);
    },
    progress(xhr) {
      if (xhr.loaded == xhr.total) {
        this.modelView.showProgress = false;
      } else {
        this.modelView.progress = Math.ceil(
          ((xhr.loaded / xhr.total) * 100).toFixed(2)
        );
      }
    },
    modelLoadFinish(data) {
      this.showOpactyButton = data.hasOpactyMesh;
    },
    stringToHex: function (str) {
      var val = "";
      for (var i = 0; i < str.length; i++) {
        //先转成unicode编码,再转成对应的16进制
        val += "" + str.charCodeAt(i).toString(16);
      }
      return val;
    },

    //数据据可视化
    onSenssionClick: function () {
      this.showDataBox = !this.showDataBox;
    },
    onSenssionMessage: function (msg) {
      this.hum = "湿度：" + msg.hum / 100 + "%";
      this.temp = "温度：" + msg.temp / 100 + "℃";
    }
  },
};

//颜色转换

function colorRgb(rgb) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  var color = rgb.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }

    // 处理六位的颜色值，转为RGB
    var colorChange = [];
    for (var j = 1; j < 7; j += 2) {
      colorChange.push(parseInt("0x" + color.slice(j, j + 2)));
    }
    return "rgb(" + colorChange.join(",") + ")";
  } else {
    return color;
  }
}
</script>

<style scoped>
.body {
  width: 100%;
  height: 100%;
}

.footer {
  position: absolute;
  bottom: 24px;
  width: 100%;
}

.foot_button {
  margin-right: 10px;
  height: 64px;
  width: 64px;
}

.colorpicker_container {
  width: 100%;
  height: 100%;
  position: absolute;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
}

.shareDrawer {
  mask: false;
  overflow: visible;
  display: flex;
}

.introdution {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.836);
  width: 100%;
  height: 100%;
}

.hotPoint {
  width: 100px;
  height: 100px;
  background: tomato;
}

.container {
  width: 100%;
  height: 100%;
  position: absolute;
  /* pointer-events:none; */
}

.uiContainer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}

/* 数据据可视化 */
.baseBoxLeft {
  width: 500px;
  height: 666px;
  background: url(../../../assets/senssion/left.png) no-repeat;
  background-size: contain;
  position: absolute;
  top: 100px;
  left: 48px;
}

.boxTitle {
  font-size: 30px;
  color: #0efcff;
  width: 120px;
  margin-left: 40px;
  margin-top: 18px;
  text-align: left;
  position: absolute;
}

.cameraList {
  width: 460px;
  height: 200px;
  margin: 50px auto auto 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.camera {
  width: 230px;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.camera_content {
  width: 200px;
  height: 120px;
}

.camera_text {
  color: #0efcff;
}

.senssion {
  width: 460px;
  height: 300px;
  color: #0efcff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 30px auto auto 20px;
  justify-content: space-around;
}

.senssion_item {
  width: 110px;
  height: 110px;
  margin: 2px;
}

.leftbar {
  user-select: none;
  width: 80px;
  height: 200px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  justify-content: space-around;
  margin: -100px 0 0 30px;
}

.leftbar-item {
  user-select: none;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.leftbar-item-image {
  user-select: none;
  width: 40px;
  height: 40px;
}

.floor_shower {
  text-align: center;
  color: #3fa9f5;
  user-select: none;
}
</style>
